import { get, groupBy, first } from 'lodash';
import moment from 'moment';
import { getMessage } from 'utils';

export const transformTimeLineData = (inDataList = []) => {
  const dataList = inDataList
    // .filter((r) => r.NGAY_HANHTRINH)
    .map((r) => {
      const d = moment(r.date_create);
      return {
        ...r,
        GHI_CHU: `[ ${r.name || r.o_name || '-'} ] ${r.note || ''}  ${
          r.p_code || ''
        }`,
        DATE_TITLE: d.format('DD/MM'),
        SUB_TITLE: d.format('HH:mm'),
        DATE: d.date(),
        MONTH: d.month(),
        FF: d.format('HH:mm'),
      };
    })
    .reverse();

  const truncList = [];
  for (let i = 0; i < dataList.length; i++) {
    if (i === 0) {
      dataList[i].GHI_CHU = 'CREATED';
    }
    truncList.push(dataList[i]);
    // add space date
    // if (get(dataList, `${i + 1}.DATE_TITLE`)) {
    //   const startDate = dataList[i].DATE;
    //   const finishDate = dataList[i + 1].DATE;

    //   const fromMonth = dataList[i].MONTH;
    //   const toMonth = dataList[i + 1].MONTH;

    //   for (let m = fromMonth; m <= toMonth; m++) {
    //     const fromDate =
    //       m === fromMonth
    //         ? startDate
    //         : moment().month(m).startOf('months').date();
    //     const toDate =
    //       m === toMonth ? finishDate : moment().month(m).endOf('months').date();
    //     for (let d = fromDate; d < toDate; d++) {
    //       if (dataList.some((v) => v.DATE === d && v.MONTH === m)) continue;
    //       if (m <= fromMonth && d < startDate) continue;
    //       if (m > fromMonth && d > finishDate) continue;
    //       const DATE_TITLE = `${('0' + d).slice(-2)}/${('0' + (m + 1)).slice(
    //         -2
    //       )}`;
    //       truncList.push({
    //         EMPTY: true,
    //         DATE_TITLE,
    //         SUB_TITLE: `${DATE_TITLE} 00:00`,
    //       });
    //     }
    //   }
    //   continue;
    // }
  }
  const groupByData = groupBy(truncList.reverse(), 'DATE_TITLE');

  const resultList = [];
  for (const k in groupByData) {
    const groupByTime = groupBy(groupByData[k], 'SUB_TITLE');
    let rows = [];

    for (const t in groupByTime) {
      if (!groupByTime[t]) continue;
      // filter Nhan tai
      const c1 = groupByTime[t].some((v) =>
        String(v.GHI_CHU).includes('Nhận tại')
      );
      if (c1) {
        // filter null
        rows.push(first(groupByTime[t].filter(Boolean)));
        continue;
      }

      // filter Nhan tu
      const c2 = groupByTime[t].some((v) =>
        String(v.GHI_CHU).includes('ĐÃ NHẬN')
      );
      if (c2) {
        rows.push(first(groupByTime[t].filter(Boolean)));
        continue;
      }

      rows = rows.concat(groupByTime[t].filter(Boolean));
    }

    resultList.push({
      DATE_TITLE: k,
      ITEMS: rows,
    });
  }
  return resultList;
};
